export default {
  AUTH (state) {
    return state.auth
  },
  TOKEN (state) {
    return state.token
  },
  USER (state) {
    return state.user
  },
  ROLE (state) {
    return state.role
  },
  OPERATIONS(state) {
    // let operations = {}
    // if(state.role?.operations){
    //   for(const name in state.role?.operations){
    //     if(!operations[state.role?.operations[name]]){
    //       operations[operation.operation.ability] = {}
    //     }
    //
    //     operations[operation.operation.ability][operation.operation.entity] = {
    //       entity: operation.operation.entity,
    //       name: operation.operation.name
    //     }
    //   }
    // }
    return state.operations
  },
  USER_FULLNAME (state) {
    if (!state.user) {
      return 'Нет данных о пользователе'
    } else {
      return `${state.user.first_name} ${state.user.last_name}`
    }
  },
  ACCESS_PANEL (state) {
    return state.user && state.user?.role === 'admin'
  },
  ACCESS_EDIT (state) {
    return state.user && (state.user?.role === 'admin' || state.user?.role === 'editor')
  }
}